import dayjs from 'dayjs';

import type {ChannelApiModel} from '../../../api/channel';
import type {ThemeColor} from '../../../styles';

import {datetimeObjToISOString} from '../../datetime';

/**
 * Returns badge color based on channel's unresponded post date
 * Need for b2b coaches only
 */
export const getChannelBadgeColor = (
  channel: ChannelApiModel,
): ThemeColor | undefined => {
  const unrespondedDate = channel.coach_unresponded_post_date;

  if (!unrespondedDate) {
    return;
  }

  const diffInHours = dayjs().diff(
    dayjs(datetimeObjToISOString(unrespondedDate)),
    'h',
  );

  if (diffInHours < 6) {
    return 'core';
  } else if (diffInHours >= 6 && diffInHours < 10) {
    return 'lostColors.chatBadge1';
  } else if (diffInHours >= 10 && diffInHours < 15) {
    return 'goal.goal3';
  } else {
    return 'error';
  }
};
